/**
 * ProductTourCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')
/* @ngInject */
export default function ProductTourCtrl ($scope, $uibModal, authSvc, productTour) {
  const vm = this
  vm.editable = authSvc.hasAccess('editAppsSettings')

  vm.isNew = false
  vm.productTour = productTour

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, item) {
    item.selected = true
    return list.slides.filter(item => item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.slides = list.slides.filter((item) => !item.selected)
    list.slides.forEach((slide, index) => { slide.sortOrder = index })
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, form) {
    form.$setDirty()
    items.forEach(item => { item.selected = false })
    list.slides = list.slides.slice(0, index)
      .concat(items)
      .concat(list.slides.slice(index))
    return true
  }

  /**
   * Count of selected slides
   *
   * @memberof mwApp/packages.controller:ProductTourCtrl
   * @param slides
   * @returns Number
   */
  vm.countSelectedItems = function (slides = []) {
    return slides.filter(item => item.selected).length
  }

  vm.addSlide = vm.editSlide = function ($event, slide, type = 'add') {
    if (type === 'add' && vm.productTour.slides.length > 9) return

    vm.stopEvent($event)

    $uibModal.open({
      templateUrl: 'components/settings/views/productTourAddSlide.html',
      controller: 'ProductTourAddSlideCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        productTourSlide: function () {
          return angular.copy(slide) || {}
        },
        isNew: function () {
          return !slide
        }
      }
    }).result
      .then(
        function close (data) {
          $scope.form.$setDirty()
          if (slide) {
            Object.assign(slide, data.productTourSlide)
          } else {
            const sortOrder = productTour.slides.length && productTour.slides[productTour.slides.length - 1].sortOrder + 1
            productTour.slides.push({ ...data.productTourSlide, sortOrder })
          }
        }
      )
  }

  /**
   * Get preview image URL
   *
   * @memberof models.ProductTour#
   * @return {String}
   */
  vm.previewImageUrl = function (slide) {
    return slide.horizontalImageUrl || slide.verticalImageUrl
  }

  /**
   * Delete Slide
   *
   * @memberof mwApp/shows.controller:ProductTourCtrl
   * @param {Number} index
   * @param {Object} form
   * @param {model.ProductTour} pt - entity
   */
  vm.deleteSlide = function (index, form, pt = productTour) {
    form.$setDirty()
    pt.slides.splice(index, 1)
  }

  /**
   * Delete few Slides from Product Tour
   *
   * @memberof mwApp/packages.controller:ProductTourCtrl
   */
  vm.deleteSlides = function (form) {
    form.$setDirty()
    productTour.slides = productTour.slides.filter(slide => !slide.selected)
  }

  /**
   * Save changes in Product Tour
   *
   * @memberof mwApp/packages.controller:ProductTourCtrl
   */
  vm.submit = function () {
    vm.setDisable()

    productTour._save()
      .then(vm.location(productTour).reload)
      .finally(vm.unsetDisable)
  }
}
